module.exports = __webpack_public_path__ + "static/media/20900034-aoB0wSgs.32d9988d.JPG";